import httpService from "services/api.service";

const BASE_URL = "/kas_deposit";

export const getKasDeposit = async (payload) => {
  try {
    const res = await httpService.get(BASE_URL, { params: payload });
    return res;
  } catch (error) {
    throw error.message;
  }
};

export const getKasDetail = async (id) => {
  try {
    const res = await httpService.get(`kas?id_kas=${id}`);
    return res;
  } catch (error) {
    throw error.message;
  }
};

export const approvalKasDeposit = async (payload) => {
  try {
    const res = await httpService.post("/approve_kas_deposit", payload, {
      headers: { "Content-Type": "application/json" },
    });
    return res;
  } catch (error) {
    throw error.message;
  }
};
